// assets/src/components/DropdownToggle.js
import $ from 'jquery';

/**
 * Delegated click-handler that toggles `.is-open`
 * on any element referenced by data-dropdown.
 *
 * It now also closes the dropdown when you click
 * anywhere outside `.nalu-picker-dropdown`.
 */
export function initDropdownToggles(context = document) {
  const $context = $(context);

  // The surfaced (inline) calendar is open at all times by design. The
  // "close the calendar" logic below must skip it — it never carries
  // `.is-hidden`, so trying to close it makes the synthetic #nalu-date-picker
  // click bubble back into the global handler and recurse forever.
  const isInlineCalendar = () =>
    document.getElementById('nalu-date-picker')?.dataset?.inline === '1';

  /* ───────────── 1. OPEN / TOGGLE (Passengers) ───────────── */
  $context.on('click', '.nalu-picker-datepicker', function (e) {
    e.stopPropagation();                       // keep the outside-click handler quiet

    const selector = $(this).data('dropdown'); // e.g. ".nalu-picker-col--passengers"
    if (!selector) return;

    // If a (dropdown) Pikaday calendar is visible, close it via the date button.
    const $calendar = $('.pika-single');
    if (!isInlineCalendar() && $calendar.length && !$calendar.hasClass('is-hidden')) {
      // This will call DatePicker's click handler, which runs picker.hide()
      $('#nalu-date-picker').trigger('click');
    }

    // Close any other open dropdowns first
    $('.nalu-picker-col.is-open').not(selector).removeClass('is-open');

    // Toggle the target dropdown (passengers)
    $(selector).toggleClass('is-open');
  });

  /* ───────────── 2. KEEP IT OPEN WHILE INSIDE ───────────── */
  // any click inside the dropdown should not bubble up
  $context.on('click', '.nalu-picker-dropdown', function (e) {
    e.stopPropagation();
  });

  /* ───────────── 3. GLOBAL “CLICK-OUTSIDE” HANDLER ───────────── */
  $(document).on('click', function (e) {
    // if the click did NOT happen on the trigger or inside the dropdown…
    if (!$(e.target).closest('.nalu-picker-dropdown, .nalu-picker-datepicker').length) {
      // Close every open picker
      $('.nalu-picker-col.is-open').removeClass('is-open');

      // Also close datepicker calendar if it's open — but never the inline one
      // (always-open by design; closing it recurses through this handler).
      const $calendar = $('.pika-single');
      if (!isInlineCalendar() && $calendar.length && !$calendar.hasClass('is-hidden')) {
        $('#nalu-date-picker').trigger('click');
      }
    }
  });
}
